// Small display helpers. Pure functions, no side effects.

export function currency(n) {
  if (n == null || Number.isNaN(Number(n))) return '—'
  return '$' + Math.round(Number(n)).toLocaleString('en-US')
}

export function priceRange(low, high) {
  if (low == null || high == null) return '—'
  if (Math.round(low) === Math.round(high)) return currency(low)
  return `${currency(low)}–${currency(high)}`
}

// Digits-only phone for submission.
export function normalizePhone(v) {
  return String(v || '').replace(/\D/g, '')
}

// Pretty US phone as the user types: (561) 555-1234
export function formatPhoneInput(v) {
  const d = normalizePhone(v).slice(0, 10)
  if (d.length === 0) return ''
  if (d.length < 4) return `(${d}`
  if (d.length < 7) return `(${d.slice(0, 3)}) ${d.slice(3)}`
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`
}

export function maskPhone(v) {
  const d = normalizePhone(v)
  if (d.length < 4) return v || ''
  return `(•••) •••-${d.slice(-4)}`
}

export function isValidPhone(v) {
  return normalizePhone(v).length === 10
}

export function isValidEmail(v) {
  if (!v) return true // email is optional
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v).trim())
}
